<template>
  <div class="hero">
    <div class="container-hero">
        <div class="card-hero-contains" v-for="item in arrayCripto" :key="item.key">
            <div class="card blue-grey darken-1">
                <div class="card-content white-text">
                    <span class="card-title">{{item.mainSymbol}}</span>
                    <p>Price: {{item.price}}</p>
                    <p>Balance: {{item.c}}</p>
                    <p>24H: {{item.c2d}}</p>
                    <p>Initial full status: {{item.initialFullStatus}}</p>
                </div>
                <div class="card-action">
                    <router-link :to="'/grafica/chart?symbol='+item.mainSymbol">
                        <a href="">Grafica en barras</a>
                    </router-link>
                    <router-link :to="'/graficaLineal?symbol='+item.mainSymbol">
                        <a href="">Grafica Lineal</a>
                    </router-link>
                    <router-link :to="'/chartHistory?symbol='+item.mainSymbol">
                        <a href="">historialC</a>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { generalStatus } from '../services/multiSnifferService'
import app from '../App'
import grafica from './grafica.vue'
export default {
  name: 'index',
  props: ['arrayCripto'],
  components: {
    grafica
  },
  data () {
    return {
      app
    }
  },
  computed: {

  },
  methods: {
    async loadData () {
      let res = await generalStatus()
      this.arrayCripto = res.data
      this.arrayCriptoOriginal = res.data
    }

  },
  mounted () {
    this.loadData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hero{
        margin: 5% 10%;
    }
    .container-hero{
       display: grid;
       grid-template-columns: repeat(4,1fr);
       grid-template-rows: repeat(3,1fr);
       grid-gap:10px
    }
    .card-hero-contains{
        border: 1px solid #6d7278 ;
        border-radius: 5px;
        background: #42748a;
        color: white;
    }

    .card-hero-contains:hover{
        background: #6c8f9e;
        box-shadow: 3px 3px 3px #3e5252;
    }

    .card-action{
        display: grid;
        grid-template-columns: repeat(2,1fr);
        border-top: 1px solid #6d7278;
    }

    .card-action a{
        color: white;
        text-decoration: none;
        padding: 10px;
    }

    .card-action a:hover{
        color: black;
        background: grey;
        border-radius:10px ;
    }
    .card-title{
        font-size: 24px;
    }

    @media  (max-width: 1600px) {
        .hero{
            font-size: small;
        }
    }

    @media (max-width: 960px) {
        .hero{
            margin-top: 7%;
        }

        .container-hero{
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 700px){
        .hero{
            margin-top: 12%;
            font-size: x-small;
        }
    }

    @media (max-width: 320px){
        .hero{
            margin-top: 20%;
        }
        .container-hero{
            display: grid;
            grid-template-columns: 1fr;
        }

        .card-hero-contains:hover{
            background: #6c8f9e;
            box-shadow: 3px 3px 3px #3e5252;
        }

        .card-action a:hover{
            color: black;
            background: grey;
            border-radius:10px ;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/index.vue